// extracted by mini-css-extract-plugin
export default {"headline":"Public_headline__yuxLJ","wrapper":"Public_wrapper__hKgEE"};